export default function IconRecycleBinThrow({ className = "w-5 h-5" }: { className?: string }) {
	return (
		<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
			<path d="M10 9.64133V15.0763" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M12.5728 12.1512C11.6917 11.1171 11.147 10.5442 10.154 9.70527C10.0561 9.62257 9.91321 9.61969 9.81237 9.69876C8.82829 10.4705 8.2727 11.0474 7.36914 12.1512"
				stroke="currentColor"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3.30347 8.526L3.82772 15.8655C3.91361 17.068 4.79086 18.0772 5.98571 18.2369C8.66528 18.595 11.3345 18.595 14.0141 18.2369C15.2089 18.0772 16.0861 17.068 16.1721 15.8655L16.6963 8.526"
				stroke="currentColor"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M1.62939 5.27914H18.3705" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M6.65161 5.17778L7.30437 3.38272C7.71653 2.24927 8.79375 1.49475 9.99983 1.49475C11.2059 1.49475 12.2831 2.24927 12.6953 3.38272L13.348 5.17778"
				stroke="currentColor"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
